import {create} from 'zustand';
export const useVendorsStore = create((set) => ({
    vendors: null,
    vendor: null,
    products: null,
    productSets: null,
    documents: null,
    warehouseSales: null,
    productOverview: null,
    setWarehouseSales: (warehouseSales) => set({ warehouseSales }),
    setProductOverview: (productOverview) => set({ productOverview }),
    setProductSets: (productSets) => set({ productSets }),
    setProducts: (products) => set({ products }),
    setDocuments: (documents) => set({ documents }),
    setVendors: (vendors) => set({ vendors }),
    setVendor: (vendor) => set({ vendor }),
}));